import ChallengesScreen from "./challengesScreen";
import NavigationTipsScreen from "./NavigationTipsScreen";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ChallengesScreen,
  NavigationTipsScreen
};
